<template>
  <div class="flex flex-wrap white-bg col-12">
    <div
      v-if="errorMessage"
      class="flex flex-wrap justify-center col-12 pt2 px2 white-bg red"
    >
      <div class="col-12 p2 center">{{ errorMessage }}</div>
    </div>
    <div class="flex flex-wrap col-12 white-bg px1 pt2">
      <!-- GENDER ADD -->
      <div
        v-if="genderInput && genderInput.values"
        class="flex flex-wrap justify-center col-12 p1 center"
      >
        <div
          v-for="(type, index) in genderInput.values"
          :key="index"
          class="flex col-6"
          @click="selectGender(type.value)"
        >
          <label class="flex flex-column col-12 pointer rounded justify-center items-center" :for="type.id">
            <div
              class="flex justify-center custom-radio user-icon"
              :class="[
                {
                  'grey-bg': !isGenderSelected(type.value),
                  'light-blue-bg': isGenderSelected(type.value),
                },
              ]"
            >
              <i class="icon flex h1 white" :class="[type.icon]"></i>
            </div>
            <span class="flex h5 m1 bold block">{{ type.label }}</span>
          </label>
        </div>
      </div>

      <div
        v-for="(input, index) in inputs"
        :key="index"
        class="flex col-6 sm-col-12"
      >
        <InputField
          v-if="!input.hideInput"
          class="col-12"
          :value="input.value"
          :name="input.name"
          :label="input.label"
          :type="input.type"
          :placeholder="input.placeholder"
          :pattern="input.pattern"
          :required="input.required"
          :props="input.props"
          @update:value="v => { input.value = v; }"
        />
      </div>
    </div>

    <div class="flex flex-wrap col-12">
      <div class="col-12 p2 flex justify-end items-center">
        <Button
          v-if="!loading"
          class="col-4 sm-col-6 ml2"
          :disabled="!isFormValid"
          :action="handleCreateParticipant"
          text="Suivant"
        />
        <Button
          v-else
          class="col-4 sm-col-6 ml2"
          :disabled="true"
          icon="icon icon-loader"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  addDays,
  format,
  isValid,
  isWithinInterval,
  parse,
  startOfDay,
  subYears
} from 'date-fns';
import InputField from '@/components/participants/InputField.vue';
import Button from '@/components/elements/Button.vue';

import { createParticipant } from '@/utils/requests';

export default {
  components: {
    InputField,
    Button
  },
  data () {
    return {
      loading: false,
      errorMessage: null,
      inputs: [
        {
          value: null,
          name: 'firstname',
          label: 'Prénom',
          type: 'text',
          required: true
        },
        {
          value: null,
          name: 'lastname',
          label: 'Nom de famille',
          type: 'text',
          required: true
        },
        { value: null, name: 'email', label: 'Email', type: 'email' },
        {
          value: null,
          name: 'birthdate',
          label: 'Date de naissance',
          type: 'date',
          placeholder: 'DD/MM/YYYY',
          required: true,
          rule: age => {
            if (!age) return false;
            const d = parse(age, 'dd/MM/yyyy', startOfDay(new Date()));
            return isValid(d) && isWithinInterval(d, {
              start: addDays(subYears(startOfDay(new Date()), 100), 1),
              end: startOfDay(new Date())
            });
          },
          props: { minDate: addDays(subYears(startOfDay(new Date()), 100), 1) }
        },
        {
          value: null,
          name: 'gender',
          type: 'text',
          hideInput: true,
          required: true,
          values: [
            { label: 'Monsieur', id: 'male', value: 'mr', icon: 'icon-torso' },
            {
              label: 'Madame',
              id: 'female',
              value: 'mme',
              icon: 'icon-torso-female'
            }
            // { label: 'Mademoiselle', id: 'miss', value: 'miss', icon: 'icon-torso-female' }
          ]
        }
      ]
    };
  },
  computed: {
    genderInput () {
      return this.inputs.find(i => i.name === 'gender');
    },
    isFormValid () {
      return this.inputs.every(input => {
        if (input.required && !input.value) {
          return false;
        }
        if (input.hasOwnProperty('rule') && !input.rule(input.value)) {
          return false;
        }

        return true;
      });
    }
  },
  methods: {
    buildFormValues () {
      return this.inputs.reduce((acc, input) => {
        acc[input.name] = input.value;
        return acc;
      }, {});
    },
    isGenderSelected (value) {
      return this.genderInput.value === value;
    },
    selectGender (value) {
      this.genderInput.value = value;
    },
    async handleCreateParticipant () {
      this.errorMessage = null;
      if (!this.isFormValid) return;

      const body = this.buildFormValues();
      const birthRaw = body.birthdate;
      const birthParsed = birthRaw ? parse(birthRaw, 'dd/MM/yyyy', new Date()) : null;
      if (!isValid(birthParsed)) {
        this.errorMessage = 'Date de naissance invalide. Utilisez le format JJ/MM/AAAA (ex. 15/04/1990).';
        return;
      }

      this.loading = true;
      try {
        const res = await createParticipant({
          ...body,
          email: body.email || this.$store.state.user.email,
          birthdate: format(birthParsed, 'yyyy-MM-dd'),
          user: this.$store.state.user
        });

        if (res && res.loginUrl) return;

        const customer = res && res.customer;
        const code = res && res.code;
        if (res && res.message && !customer) {
          this.errorMessage = res.message;
          return;
        }
        if (customer) {
          this.$store.commit('setUser', customer);
          this.$emit('close');
          return;
        }
        switch (code) {
          case 'ERROR_1':
            this.errorMessage = 'Veuillez utiliser des informations de contact différentes.';
            break;
          default:
            this.errorMessage = 'Erreur inconnue. Veuillez contacter notre support.';
            break;
        }
      } catch (e) {
        this.errorMessage = 'La requête a échoué. Réessayez ou contactez le support.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.icon:before {
  display: flex;
  align-items: center;
}
</style>
